<template>
  <AuthShell kicker="تأیید ورود" code="V-02" title="کد ورود را وارد کنید">
    <template #top><router-link to="/login" class="auth-link">ویرایش شماره</router-link></template>
    <p class="verify-note">کد پنج‌رقمی به شماره <bdi class="vn-mono">{{ phoneNumber }}</bdi> پیامک شد.</p>
    <form @submit.prevent="submitOTP" novalidate>
      <label for="verification-code">کد ورود</label>
      <input id="verification-code" ref="codeInput" class="auth-input code-input" type="text" inputmode="numeric" autocomplete="one-time-code" maxlength="5" dir="ltr" v-model="codeOtp" :disabled="loading" placeholder="•••••" />
      <p v-if="errorMessage" class="auth-error" role="alert">{{ errorMessage }}</p>
      <button type="submit" class="auth-submit" :disabled="loading || codeOtp.length !== 5" :aria-busy="loading">{{ loading ? 'در حال بررسی…' : 'تأیید و ورود' }}</button>
    </form>
    <div class="resend" aria-live="polite">
      <span v-if="timerCount > 0">ارسال دوباره تا <b class="vn-num">{{ timerLabel }}</b></span>
      <button v-else type="button" class="auth-link" @click="resendCodeClick" :disabled="loading">ارسال دوباره‌ی کد</button>
    </div>
  </AuthShell>
</template>
<script>
import AuthShell from '@/components/AuthShell/index.vue';

export default {
  components: { AuthShell },
  data() { return { codeOtp: '', loading: false, timerCount: 120, errorMessage: '' }; },
  computed: {
    phoneNumber() { return this.$STORE.state.userConfig.userPhoneNumber; },
    timerLabel() { const m = Math.floor(this.timerCount / 60), s = this.timerCount % 60; return `${m}:${String(s).padStart(2, '0')}`; },
  },
  watch: {
    codeOtp(value) {
      const normalized = value.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d)).replace(/[٠-٩]/g, d => '٠١٢٣٤٥٦٧٨٩'.indexOf(d)).replace(/\D/g, '').slice(0, 5);
      if (value !== normalized) this.codeOtp = normalized;
      this.errorMessage = '';
    },
  },
  mounted() { this.$refs.codeInput.focus(); this.startTimer(); },
  beforeDestroy() { clearInterval(this.countdown); },
  methods: {
    startTimer() {
      clearInterval(this.countdown);
      this.countdown = setInterval(() => { if (this.timerCount > 0) this.timerCount--; else clearInterval(this.countdown); }, 1000);
    },
    async resendCodeClick() {
      if (this.loading || this.timerCount > 0) return;
      this.loading = true; this.errorMessage = '';
      try {
        const res = await this.$ApiServiceLayer.post(this.$PATH.RELATIVE_PATH.POST.PHONE_NUMBER_OTP_REQ, this.$PATH.SERVICE_NAME.AUTH, { phone_number: this.phoneNumber }, {}, false);
        if (res.status === 201) {
          this.$STORE.commit('userConfig/setOtpId', res.data.id);
          this.$STORE.commit('userConfig/setLoginTempToken', res.data.verification_token);
          this.timerCount = 120; this.codeOtp = ''; this.startTimer();
        } else this.errorMessage = 'ارسال دوباره‌ی کد انجام نشد. دوباره تلاش کنید.';
      } finally { this.loading = false; }
    },
    async submitOTP() {
      if (this.loading || !/^[0-9]{5}$/.test(this.codeOtp)) return;
      this.loading = true; this.errorMessage = '';
      try {
        const res = await this.$ApiServiceLayer.post(this.$PATH.RELATIVE_PATH.POST.OTP_VERIFY, this.$PATH.SERVICE_NAME.AUTH, { code: this.codeOtp, verification_token: this.$STORE.state.userConfig.loginTempToken, id: this.$STORE.state.userConfig.otpId, phone_number: this.phoneNumber }, {}, false);
        if (res.status === 200 && res.data.tokens) {
          this.$STORE.commit('userConfig/setAccessToken', 'Bearer ' + res.data.tokens.access);
          this.$STORE.commit('userConfig/setRefreshToken', res.data.tokens.refresh);
          this.$STORE.commit('userConfig/setUserInfo', res.data.user);
          this.$STORE.commit('userConfig/setUserRole', res.data.role ? res.data.role.role : null);
          this.$STORE.commit('userConfig/setProjectInfo', null);
          this.$STORE.commit('userConfig/setOtpId', '');
          this.$STORE.commit('userConfig/setLoginTempToken', '');
          this.$router.push({ name: 'projects' });
        } else this.errorMessage = res.status === 0 ? 'ارتباط با سرور برقرار نشد.' : 'کد معتبر نیست یا منقضی شده است. دوباره بررسی کنید.';
      } finally { this.loading = false; }
    },
  },
};
</script>
<style scoped>
.verify-note { color: #3D4870; font-size: 14px; margin: -2px 0 24px; }
.verify-note bdi { font-weight: 700; color: var(--navy-900); }
.code-input { font-family: var(--mono); font-size: 24px !important; letter-spacing: .6em; text-align: center; }
.resend { margin-top: 18px; font-size: 13px; color: #4A557E; }
.resend b { color: var(--navy-900); }
</style>
